import script from "./packages.vue?vue&type=script&setup=true&lang=js"
export * from "./packages.vue?vue&type=script&setup=true&lang=js"

import "./packages.vue?vue&type=style&index=0&id=b532eb8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b532eb8e"]])

export default __exports__